import { createTheme } from "@mui/material";
import { blueGrey, common, grey } from "@mui/material/colors";
import { ptBR } from "@mui/material/locale";

// A custom theme for this app

declare module "@mui/material/styles" {
  interface Theme {
    messageBox: {
      received: {
        background: string;
      };
      sended: {
        background: string;
      };
    };
    textInput: {
      background: string;
    };
    chat: {
      background: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    messageBox?: {
      received?: {
        background?: string;
      };
      sended?: {
        background?: string;
      };
    };
    textInput?: {
      background?: string;
    };
    chat?: {
      background?: string;
    };
  }
}

const defaultLightTheme = (color: any) =>
  createTheme({
    palette: {
      primary: { main: color || "#2478B1" },
      secondary: { main: common.white },
    },
  });

const lightTheme = (color: any, sendedColor: any, background: any) =>
  createTheme(
    defaultLightTheme(color),
    {
      messageBox: {
        received: {
          background: "white",
        },
        sended: {
          background: sendedColor || "#5ecbfc",
        },
      },
      textInput: {
        background: "transparent",
      },
      chat: {
        background: background || grey[300],
      },
      palette: {
        action: { hoverOpacity: 0.18 },
        contrastThreshold: 6,
        tonalOffset: 0.2,
      },
    },
    ptBR
  );

const defaultDarkTheme = (color: any) =>
  createTheme({
    palette: {
      mode: "dark",
      primary: { main: color || "#2478B1" },
      secondary: { main: common.white },
    },
  });

const darkTheme = (darkColor: any, darkSendedColor: any, darkBackground: any) =>
  createTheme(
    defaultDarkTheme(darkColor),
    {
      messageBox: {
        received: {
          background: grey[800],
        },
        sended: {
          background: darkSendedColor || "#53B4DE",
        },
      },
      textInput: {
        background: grey[800],
      },
      chat: {
        background: darkBackground || blueGrey[900],
      },
      palette: {
        mode: "dark",
        secondary: { main: darkColor || "#174c70" },
      },
    },
    ptBR
  );
export { lightTheme, darkTheme };
